import { ccwpApi } from "@/services";

export const CalculationStepViewApi = ccwpApi.injectEndpoints({
    endpoints: (builder) => ({
      getCalculationStepData: builder.query<any, any>({
        query: (arg) => "/Account/GetAccountListByCase?CaseId=" + arg.caseId ,
        transformResponse: (response: { results: any[] }) => response.results,
      }),
      getCalculationStepSubAccountData: builder.query<any, any>({
        query: (arg) => `/Account/GetSubAccountListByAccount?AccountId=${arg.accountId}`,
        transformResponse: (response: { results: any[] }) => response.results,
      }),
      createCalculationStep: builder.mutation({
        query: (data) => ({
          url: "/CalculationStep/CreateStep",
          method: "POST",
          body: data,
        }),
      }),
    }),
  });

  
export const { useGetCalculationStepDataQuery, useGetCalculationStepSubAccountDataQuery,useCreateCalculationStepMutation } = CalculationStepViewApi;


export const dataSourceSummaryViewApi = ccwpApi.injectEndpoints({
    endpoints: (builder) => ({
      getDataSourceSummaryViewApiData: builder.query<any, any>({
        query: (stepId) => `/StepDataSource/GetStepDataSourceSummaryList?CalculationStepId=${stepId}`,
      }),
    }),
  });

  export const { useGetDataSourceSummaryViewApiDataQuery } = dataSourceSummaryViewApi;

  export const classFilterViewApi = ccwpApi.injectEndpoints({
    endpoints: (builder) => ({
      getClassFilterViewApiData: builder.query<any, any>({
        query: (stepId) => `/StepClassFilter/GetStepClassFilterList?calculationStepId=${stepId}`,
      }),
    }),
  });

  export const { useGetClassFilterViewApiDataQuery } = classFilterViewApi;